/* ==========================================================================
   HeaderMasterExpedient > Client > Services
   ========================================================================== */

/* Modules */
const { of } = require('rxjs');
const { catchError, switchMap } = require('rxjs/operators');
const { fromFetch } = require('rxjs/fetch');

/**
 * Get destinations from a remote server
 * @param {string} endpoint
 * @param {object} params
 * @returns {JSON} data
 */
function logout(endpoint = '') {
    /* Build url */

    return fromFetch(endpoint).pipe(
        switchMap(response => {
            if (response.ok) {
                return response.json();
            }
            return of({ error: true, message: `Error fetching data searcher ${response.statusText}` });
        }),
        catchError(err => {
            return of({ error: true, message: err.message });
        })
    );
}

/* Exports */
module.exports = {
    logout
};
